export const getLangValue: Record<string, unknown> = {
  English: 'en',
  Suomi: 'fi',
  Svenska: 'sv',
  Norsk: 'no',
  Latvia: 'lv',
  Slovenian: 'sl'
};
